"use strict";

module.exports = function (val) {
  if (val.match(/[xsz]$|ch$|sh$/)) {
    return "".concat(val, "es");
  }

  return "".concat(val, "s");
};